import { Component, Inject, OnInit } from '@angular/core';
import { AlertDTO } from 'src/app/model/alerts/alert-dto';
import { AlertsComponent } from '../alerts/alerts.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CyberAttackTypeEnum } from 'src/app/model/alerts/attacks/cyber-attack-type-enum';
import { CyberAttackDTO } from 'src/app/model/alerts/attacks/cyber-attack-dto';
import { CyberAttackManagementStatusEnum } from 'src/app/model/alerts/attacks/cyber-attack-management-status-enum';
import { AlertService } from 'src/app/services/alert.service';
import { ToastrService } from 'ngx-toastr';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';
import { CyberAttackManagementTypeEnum } from 'src/app/model/alerts/attacks/cyber-attack-management-type-enum';

@Component({
  selector: 'app-alert-features-modal',
  templateUrl: './alert-features-modal.component.html',
  styleUrl: './alert-features-modal.component.scss',
})
export class AlertFeaturesModalComponent implements OnInit {
  cyberAttackTypeEnum = CyberAttackTypeEnum;
  cyberAttackManagementStatus = CyberAttackManagementStatusEnum;
  cyberAttackManagementType = CyberAttackManagementTypeEnum;

  usersWhoManagedAlert: Map<number, string[]> = new Map();

  constructor(
    @Inject(MAT_DIALOG_DATA) public alert: AlertDTO,
    public dialogRef: MatDialogRef<AlertsComponent>,
    private readonly alertService: AlertService,
    private readonly loadIndicatorService: LoadIndicatorService,
    private readonly toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.usersWhoManagedAlert = this.getUsersWhoManagedAlert();
  }

  manage(attack: CyberAttackDTO, type: CyberAttackManagementTypeEnum) {
    this.loadIndicatorService.show();
    this.alertService
      .manageAttack(attack, type)
      .then(() => {
        this.reloadAlert();
      })
      .catch(() => {
        this.toastr.error('Error managing attack');
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  unmanage(attack: CyberAttackDTO) {
    this.loadIndicatorService.show();
    this.alertService
      .unmanageAttack(attack, false)
      .then(() => {
        this.reloadAlert();
      })
      .catch(() => {
        this.toastr.error('Error unmanaging attack');
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  getStatus(attack: CyberAttackDTO) {
    let result = this.cyberAttackManagementStatus.Done;
    if (attack.cyberAttackManagements.length == 0) {
      result = this.cyberAttackManagementStatus.NeedAction;
    }
    for (let attackManagement of attack.cyberAttackManagements) {
      if (
        attackManagement.status == this.cyberAttackManagementStatus.Pending ||
        attackManagement.status ==
          this.cyberAttackManagementStatus.PendingUnmanage
      ) {
        result = attackManagement.status;
        break;
      }
    }
    return result;
  }

  reloadAlert() {
    this.loadIndicatorService.show();
    this.alertService
      .getAlert(this.alert.id)
      .then((response) => {
        this.alert = response;
      })
      .catch(() => {
        this.toastr.error('Error reloading alert');
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  disableManage(
    attack: CyberAttackDTO,
    cyberAttackManagementType: CyberAttackManagementTypeEnum,
  ) {
    if (
      attack.type == this.cyberAttackTypeEnum.BehavioralAbnormality &&
      this.cyberAttackManagementType.Manual != cyberAttackManagementType
    ) {
      return true;
    }
    if (attack.cyberAttackManagements.length != 0) {
      let status = this.getStatus(attack);
      if (
        attack.cyberAttackManagements[0].type == cyberAttackManagementType &&
        status == this.cyberAttackManagementStatus.Done
      ) {
        return true;
      }
      if (attack.cyberAttackManagements[0].type != cyberAttackManagementType) {
        return true;
      }
    }
    return false;
  }

  private getUsersWhoManagedAlert() {
    let usersByAttack: Map<number, string[]> = new Map();
    this.alert.attacks?.forEach((attack) => {
      usersByAttack.set(attack.id, []);
      attack.cyberAttackManagements.forEach((management) => {
        if (management.user.name && management.user.surname) {
          let name = management.user.name
            ?.concat(' ')
            .concat(management.user.surname ?? '');
          let users = usersByAttack.get(attack.id)!;
          if (!users?.includes(name)) {
            users.push(name);
            usersByAttack.set(attack.id, users);
          }
        }
      });
    });
    return usersByAttack;
  }
}
